import { Flex } from "antd";
import { useState } from "react";
import Filters from "../../components/Filters";
import MainMetrics from "../../components/MainMetrics";
import TablesWrapper from "../../components/TablesWrapper";
import useProcessedDataFlowDetections from "../../hooks/useProcessedDataFlowDetections";
import {
  FLOW_DETECTIONS_METRICS,
  FLOW_DETECTIONS_TABLE_COLUMNS,
} from "../../utils/constants";
import BarChartWrapper from "./BarChartWrapper";
import HeatMapWrapper from "./HeatMapWrapper";
import TimeSeriesChartWrapper from "./TimeSeriesChartWrapper";

export default function FlowDetectionsRefact() {
  const [selectedDate, setSelectedDate] = useState();
  const [selectedPeriod, setSelectedPeriod] = useState([9, 19]);
  const [selectedZones, setSelectedZones] = useState(["all"]);
  const [selectedCollections, setSelectedCollections] = useState(["all"]);

  const getQueryParams = () => {
    if (!selectedDate) {
      return {
        zones: selectedZones,
        collections: selectedCollections,
        enabled: false,
      };
    }

    const isDefaultPeriod = selectedPeriod[0] === 9 && selectedPeriod[1] === 19;

    let params;
    if (isDefaultPeriod) {
      params = {
        date: selectedDate,
        zones: selectedZones,
        collections: selectedCollections,
        enabled: true,
      };
    } else {
      params = {
        start_datetime: `${selectedDate}T${selectedPeriod[0].toString().padStart(2, "0")}:00`,
        end_datetime: `${selectedDate}T${selectedPeriod[1].toString().padStart(2, "0")}:00`,
        zones: selectedZones,
        collections: selectedCollections,
        enabled: true,
      };
    }

    return params;
  };

  const { data: processedData, isLoading: isProcessedDataLoading } =
    useProcessedDataFlowDetections(getQueryParams());

  return (
    <Flex
      style={{ width: "100%", margin: "0 auto" }}
      justify="center"
      align="center"
      vertical
      gap={50}>
      <Filters
        isMainDataLoading={isProcessedDataLoading}
        filters={["data", "periodo", "zonas", "colecoes"]}
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
        selectedPeriod={selectedPeriod}
        setSelectedPeriod={setSelectedPeriod}
        selectedZones={selectedZones}
        setSelectedZones={setSelectedZones}
        selectedCollections={selectedCollections}
        setSelectedCollections={setSelectedCollections}
      />
      <MainMetrics
        data={processedData?.kpi_data}
        isLoading={isProcessedDataLoading}
        kpis={FLOW_DETECTIONS_METRICS}
      />
      <TablesWrapper
        data={processedData?.table_data}
        isLoading={isProcessedDataLoading}
        columns={FLOW_DETECTIONS_TABLE_COLUMNS}
        tablesName={[
          "Zonas com fluxo acima da média",
          "Zonas com fluxo abaixo da média",
        ]}
      />
      <TimeSeriesChartWrapper
        data={processedData?.graph_data}
        isLoading={isProcessedDataLoading}
      />
      <BarChartWrapper
        data={processedData?.bargraphData}
        maxZones={processedData?.maxZonesBarChart}
        isLoading={isProcessedDataLoading}
      />
      <HeatMapWrapper
        selectedDate={selectedDate}
        isLastRecordPending={processedData?.isLastRecordPending}
      />
    </Flex>
  );
}
